import React, { FunctionComponent } from 'react';

import { OrbModalConfirm } from '../../../../../../components/orb-modal-confirm';
import { i18n } from '../../../../../../helpers/i18n';
import { ConfirmSubmodalProps } from '../types';

export const PermissionsExtendedResetModal: FunctionComponent<ConfirmSubmodalProps> = (props) => {
    return (
        <OrbModalConfirm
            title={i18n('settings-v2', 'permissions-extended-reset-title')}
            confirmLabel={i18n('settings-v2', 'permissions-extended-reset-modal-confirm')}
            cancelLabel={i18n('settings-v2', 'permissions-extended-reset-modal-cancel')}
            {...props}
        >
            {i18n('settings-v2', 'permissions-extended-reset-modal-description')}
        </OrbModalConfirm>
    );
};
